import React from 'react';
import FieldLabel from 'components/form/field/field-label';

export default ({ label, labelSize }) => <FieldLabel fieldName={label} labelSize={labelSize} />;
